import { Navigate, RouteObject } from 'react-router-dom';
import { AuthentifiedLayout } from '@layout';
import { richessesHumainesRoutes } from './richessesHumaines.routes';
import { mesChantiersRoutes } from './mesChantiers.routes';
import { santeSecuriteRoutes } from './santeSecurite.routes';
import { HomePage, DesignSystemPage, SignatureUpdatePage, NotificationsPage, NewsPage, EventFeedbackPage } from '@pages';

export const authentifiedRoutes = (isLogged: boolean | null | undefined): RouteObject[] => [
    {
        element: <AuthentifiedLayout />,
        children: [
            {
                path: '/home',
                element: isLogged ? <HomePage /> : <Navigate to="/login" replace />
            },
            {
                path: '/design-system',
                element: isLogged ? <DesignSystemPage /> : <Navigate to="/login" replace />
            },
            {
                path: '/signature/update',
                element: isLogged ? <SignatureUpdatePage /> : <Navigate to="/login" replace />
            },
            {
                path: '/news',
                element: isLogged ? <NewsPage /> : <Navigate to="/login" replace />
            },
            {
                path: '/notifications',
                element: isLogged ? <NotificationsPage /> : <Navigate to="/login" replace />
            },
            {
                path: '/event-feedback',
                element: isLogged ? <EventFeedbackPage eventDestination={null} /> : <Navigate to="/login" replace />
            },
            ...richessesHumainesRoutes(isLogged),
            ...santeSecuriteRoutes(isLogged),
            ...mesChantiersRoutes(isLogged),
            {
                path: '*',
                element: <Navigate to={isLogged ? '/home' : '/login'} replace />
            }
        ]
    }
];
